import { Collection, CollectionItemDetail } from '../data/mockData'

export interface CollectionWithThumbnails extends Collection {
  itemCount: number
  thumbnails: CollectionItemDetail[]
}

export interface CollectionsResponse {
  collections: CollectionWithThumbnails[]
  stats: {
    recentItemsCount: number
    totalItems: number
  }
}

export interface CollectionWithCount extends Collection {
  itemCount: number
}

export interface PaginatedItemsResponse {
  items: CollectionItemDetail[]
  hasMore: boolean
  total: number
  page: number
  limit: number
}

export const api = {
  getCollections: async (): Promise<CollectionsResponse> => {
    const response = await fetch('/api/collections')
    if (!response.ok) {
      throw new Error('Failed to fetch collections')
    }
    return response.json()
  },

  getCollection: async (collectionId: string): Promise<CollectionWithCount> => {
    const response = await fetch(`/api/collections/${collectionId}`)
    if (!response.ok) {
      throw new Error('Failed to fetch collection')
    }
    return response.json()
  },

  getCollectionItems: async (collectionId: string, page: number = 1, limit: number = 6): Promise<PaginatedItemsResponse> => {
    const response = await fetch(`/api/collections/${collectionId}/items?page=${page}&limit=${limit}`)
    if (!response.ok) {
      throw new Error('Failed to fetch collection items')
    }
    return response.json()
  },

  getRecentlyAddedItems: async (page: number = 1, limit: number = 6): Promise<PaginatedItemsResponse> => {
    const response = await fetch(`/api/recently-added?page=${page}&limit=${limit}`)
    if (!response.ok) {
      throw new Error('Failed to fetch recently added items')
    }
    return response.json()
  }
}